import React from 'react';
import './AboutUs.css';
import TextToSpeech from './TextToSpeech';
import Header from "./Header";
import Footer from "./Footer";

/* ───────── Inline SVG icons (no extra libraries needed) ───────── */
const icons = {
  store: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 9l1.5-5h15L21 9" />
      <path d="M4 9h16v11H4z" />
      <path d="M9 20v-6h6v6" />
    </svg>
  ),
  person: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.5-6 8-6s8 2 8 6" />
    </svg>
  ),
  bag: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M6 8h12l1 13H5L6 8z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </svg>
  ),
  megaphone: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 11v3l4 1 11 5V4L7 9l-4 2z" />
      <path d="M7 15v4a1 1 0 0 0 1 1h2" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 10h18" />
    </svg>
  ),
  people: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="8" cy="9" r="3" />
      <circle cx="16.5" cy="10.5" r="2.5" />
      <path d="M2.5 20c0-3 2.5-4.5 5.5-4.5s5.5 1.5 5.5 4.5" />
      <path d="M14.5 20c.2-2.4 1.8-3.5 4-3.5 2 0 3.5 1 3.5 3.5" />
    </svg>
  ),
  cart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="20" r="1.6" />
      <circle cx="18" cy="20" r="1.6" />
      <path d="M2.5 3.5h3l2.6 12h10.4l2-8.5H7" />
    </svg>
  ),
};

/* ───────── Illustrated founder avatars (SVG   no photos) ───────── */
const AvatarMale = (
  <svg viewBox="0 0 120 120" role="img" aria-label="Illustration of a male co-founder" className="avatar-svg">
    <circle cx="60" cy="60" r="58" fill="#ede1fa" stroke="#7B1FA2" strokeWidth="3" />
    {/* shoulders / blazer */}
    <path d="M22 108c4-22 18-30 38-30s34 8 38 30" fill="#4A148C" />
    <path d="M52 82l8 10 8-10v-6H52z" fill="#fff" />
    <path d="M60 92l-4 8h8z" fill="#00796B" />
    {/* neck + head */}
    <rect x="52" y="66" width="16" height="14" rx="6" fill="#a5713f" />
    <circle cx="60" cy="48" r="21" fill="#b57e48" />
    {/* hair */}
    <path d="M39 47c0-14 9-22 21-22s21 8 21 22c0-4-3-9-6-10-2 3-6 4-15 4s-13-1-15-4c-3 1-6 6-6 10z" fill="#2c1a0e" />
    {/* face */}
    <circle cx="52.5" cy="49" r="2.2" fill="#2c1a0e" />
    <circle cx="67.5" cy="49" r="2.2" fill="#2c1a0e" />
    <path d="M53 60c2.5 2.6 11.5 2.6 14 0" stroke="#2c1a0e" strokeWidth="2" strokeLinecap="round" fill="none" />
    {/* glasses */}
    <circle cx="52.5" cy="49" r="6" fill="none" stroke="#4A148C" strokeWidth="1.6" />
    <circle cx="67.5" cy="49" r="6" fill="none" stroke="#4A148C" strokeWidth="1.6" />
    <path d="M58.5 49h3" stroke="#4A148C" strokeWidth="1.6" />
  </svg>
);

const AvatarFemale = (
  <svg viewBox="0 0 120 120" role="img" aria-label="Illustration of a female co-founder" className="avatar-svg">
    <circle cx="60" cy="60" r="58" fill="#fdeef7" stroke="#7B1FA2" strokeWidth="3" />
    {/* shoulders / blazer */}
    <path d="M22 108c4-22 18-30 38-30s34 8 38 30" fill="#7B1FA2" />
    <path d="M54 80h12v8H54z" fill="#fff" />
    {/* necklace */}
    <circle cx="60" cy="86" r="2" fill="#f2b705" />
    {/* neck + head */}
    <rect x="52" y="66" width="16" height="14" rx="6" fill="#8a5a33" />
    <circle cx="60" cy="48" r="21" fill="#9c6a3d" />
    {/* long hair behind */}
    <path d="M37 52c-2 16 2 26 6 30l6-6c-3-6-4-14-3-22zM83 52c2 16-2 26-6 30l-6-6c3-6 4-14 3-22z" fill="#1f1209" />
    {/* hair top */}
    <path d="M39 50c-1-16 9-25 21-25s22 9 21 25c-1-5-4-9-7-10-2 3-6 4-14 4s-12-1-14-4c-3 1-6 5-7 10z" fill="#1f1209" />
    {/* face */}
    <circle cx="52.5" cy="49" r="2.2" fill="#1f1209" />
    <circle cx="67.5" cy="49" r="2.2" fill="#1f1209" />
    <path d="M52 44.5c1.5-1.5 4-1.5 5.5-.5M62.5 44c1.5-1 4-1 5.5.5" stroke="#1f1209" strokeWidth="1.4" strokeLinecap="round" fill="none" />
    <path d="M53 60c2.5 2.6 11.5 2.6 14 0" stroke="#1f1209" strokeWidth="2" strokeLinecap="round" fill="none" />
    {/* earrings */}
    <circle cx="39.5" cy="54" r="2" fill="#f2b705" />
    <circle cx="80.5" cy="54" r="2" fill="#f2b705" />
  </svg>
);

const features = [
  { icon: icons.store, label: 'Discover local businesses' },
  { icon: icons.person, label: 'Find trusted professionals' },
  { icon: icons.bag, label: 'Explore products and cuisines' },
  { icon: icons.megaphone, label: 'Promote your services' },
  { icon: icons.calendar, label: 'Attend  ' },
  { icon: icons.people, label: 'Connect across cultures' },
];

const pillars = [
  {
    title: 'Connecting',
    highlight: 'Businesses',
    text: 'From grocery stores to restaurants, boutiques to salons  every community business gets a home.',
  },
  {
    title: 'Empowering',
    highlight: 'Communities',
    text: 'A space where every culture is celebrated and everyone belongs, starting in San Antonio, Texas.',
  },
  {
    title: 'Creating',
    highlight: 'Opportunities',
    text: 'Vendors, professionals, creators, and neighbors come together to buy, sell, promote, and grow.',
  },
];

function AboutUs() {
  const fullText = `
    Welcome to GoOurHub, your community marketplace. GoOurHub is a digital home for every community.
    We turn the richness of diversity into everyday connection  one place to discover local businesses,
    find trusted professionals, explore products and cuisines, promote services, attend events, and
    connect across cultures. Meet HubMart, the marketplace inside GoOurHub, where community vendors
    showcase and sell their products  from cultural foods and fashion to handmade goods  all in one
    trusted place. Built by us, for us: GoOurHub was born from a shared dream of two tech and business
    visionaries one man and one woman from diverse backgrounds who came together to bridge gaps and
    build connections. Having lived across four continents  North America, Europe, Africa, and Asia 
    and speaking multiple languages, they bring over 25 years of combined experience in technology and
    innovation, and a deep commitment to inclusion and unity. Connecting businesses. Empowering
    communities. Creating opportunities. Interested in partnering with us or showcasing your business
    on GoOurHub? Contact us today.
  `;

  return (

  

<>
  

  <Header/>
  
    <div className="about-us-container" id="about-us">
      <div className="about-us-logo"></div>

      {/* ── Hero: eyebrow + headline + mission ── */}
      <p className="about-eyebrow">What We Are</p>
      <h2 className="about-headline">
        GoOurHub: <span className="headline-accent">A Digital Home for Every Community</span>
      </h2>
      <p className="about-mission">
        <span>GoOurHub</span> turns the richness of diversity into everyday connection {' '}
        <strong className="mission-accent">one place</strong> to:
      </p>

      <TextToSpeech text={fullText} />

      {/* ── Icon feature list ── */}
      <ul className="feature-list">
        {features.map((f) => (
          <li key={f.label} className="feature-item">
            <span className="feature-icon">{f.icon}</span>
            <span className="feature-label">{f.label}</span>
          </li>
        ))}
      </ul>

      {/* ── HubMart spotlight ── */}
      <section className="hubmart-section">
        <div className="hubmart-icon">{icons.cart}</div>
        <p className="about-eyebrow eyebrow-light">Shop the Community</p>
        <h3 className="hubmart-title">
          Introducing <span className="hubmart-name">HubMart</span>
        </h3>
        <p className="hubmart-text">
          HubMart is the marketplace inside <span>GoOurHub</span>  where community vendors showcase
          and sell their products, from cultural foods and fashion to handmade goods and everyday
          essentials. Every purchase supports a local business and keeps opportunity circulating
          within our communities. One hub. One mart. Endless discoveries.
        </p>
        <a href="/hubmart" className="hubmart-link">Explore HubMart →</a>
      </section>

      {/* ── Built by us, for us + avatars ── */}
      <section className="builtbyus-section">
        <p className="about-eyebrow">Our Story</p>
        

        <div className="founders-row">
          <figure className="founder-card">
            {AvatarMale}
            <figcaption>
              <p className="founder-role">Co-Founder</p>
              <p className="founder-focus">Business &amp; Community</p>
            </figcaption>
          </figure>

          <div className="founders-connector" aria-hidden="true">
            <span className="connector-line"></span>
            <span className="connector-heart">＋</span>
            <span className="connector-line"></span>
          </div>

          <figure className="founder-card">
            {AvatarFemale}
            <figcaption>
              <p className="founder-role">Co-Founder</p>
              <p className="founder-focus">Technology &amp; Innovation</p>
            </figcaption>
          </figure>
        </div>

        <p className="builtbyus-text">
          <span>GoOurHub</span> was born from a shared dream of two tech and business visionaries
          from diverse backgrounds who came together with a singular purpose: to bridge gaps and
          build connections. Having each lived a decade or more across four continents  North
          America, Europe, Africa, and Asia and versatile in multiple languages, they bring over
          25 years of combined experience in technology and innovation, and a deep commitment to
          creating a platform that celebrates inclusion and unity.
        </p>
      </section>

      {/* ── Three pillars ── */}
      <div className="pillars-grid">
        {pillars.map((p) => (
          <div key={p.title} className="pillar-card">
            <h4 className="pillar-title">
              <span className="pillar-accent">{p.title}</span> {p.highlight}
            </h4>
            <p className="pillar-text">{p.text}</p>
          </div>
        ))}
      </div>

      {/* ── Collaborate CTA ── */}
      <div className="collaboration-section">
        <h3>Collaborate with Us!</h3>
        <p>
          Are you interested in partnering with us or showcasing your business on{' '}
          <span>GoOurHub</span>? We'd love to hear from you! Together, we can create a vibrant
          community hub that celebrates diversity and connection.
        </p>
        <p>
          <a href="/contact" className="contact-link">Contact Us</a> today to learn more about how
          we can collaborate and build something amazing together!
        </p>
      </div>

      <p className="about-tagline">★ GoOurHub  Where You Belong ★</p>
    </div>
       <Footer />
  </>
  );
}

export default AboutUs;
